import React from 'react'

import Modal from 'components/Modal'

import { Container, Title, Desc, Icon, Button } from './style'

const ProductModal = ({ product, group, onClose = () => {} }) => {
    return (
        <Modal open={true} onClick={onClose} closeBtn={true}>
            <Container data-testid={`${group.desc}Tooltip`}>
                <Icon
                    src={group.icon}
                    alt={`Icone ${product.name} ${group.desc}`}
                />
                <Title>{group.desc}</Title>
                <Desc>{group.tooltipDesc}</Desc>
                <Button type="button" onClick={onClose}>
                    Entendi
                </Button>
            </Container>
        </Modal>
    )
}

export default ProductModal
